<template>
  <div class="row mt15 mb30 flex">
    <label for="locations_select" class="select pointer relative select-wrapper">
      <base-select
        name="locations_select"
        id="locations_select"
        :class="{
          'cl-tertiary' : locations.length === 0,
          'empty': !currentLocationCode,
          'not-location-select' : !currentLocationCode
        }"
        :options="correctLocations"
        :selected="locationCode"
        :placeholder="$t('City *')"
        v-model="locationCode"
        @change="switchLocation"
      >
      </base-select>
    </label>
  </div>
</template>
<script>
  import HomeLocationItem from 'theme/components/theme/blocks/Locations/HomeLocationItem'
  import BaseSelect from 'src/themes/korzyna/components/core/blocks/Form/BaseSelect'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ContactSelectLocation',
    components: {
      'location-item': HomeLocationItem,
      BaseSelect
    },
    data () {
      return {
        correctLocations: [],
        locationCode: ''
      }
    },
    mounted () {
      this.locations.map(location => {
        this.correctLocations.push({
          value: location.code,
          label: location.name
        })
      })
    },
    computed: {
      ...mapGetters({
        locations: 'locations/getLocations',
        currentLocation: 'locations/getActiveLocation'
      }),
      currentLocationCode () {
        if (!this.currentLocation || typeof this.currentLocation === 'undefined' || typeof this.currentLocation === undefined) {
          return ''
        }

        return this.currentLocation.code
      }
    },
    methods: {
      ...mapActions({
        changeLocation: 'locations/setCurrentLocation'
      }),
      switchLocation () {
        this.$emit('changeLocation', this.locationCode)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  @import '~theme/css/base/text';
  $color-tertiary: color(tertiary);
  $color-black: color(black);
  $color-puerto-rico: color(puerto-rico);
  $color-hover: color(tertiary, $colors-background);

  .select-wrapper {
    select {
      @extend .h4;
      border: none;
      width: 100%;
      height: 40px;
      -moz-appearance: none;
      -webkit-appearance: none;
      border-radius: 0;
      background-color: white;
      font-size: 15px;
      cursor: pointer;
      line-height: normal;

      &:hover,
      &:focus {
        outline: none;
        border-color: $color-puerto-rico;
      }

      &:disabled,
      &:disabled + label {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
    label {
      color: #999;
      position: absolute;
      pointer-events: none;
      user-select: none;
      top: 10px;
      left: 8px;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
    }
    select:focus ~ label, select:not(.empty) ~ label {
      top: 0;
      font-size: 12px;
      color: $color-puerto-rico;
    }
  }

  .select {
    display: inline-block;
    width: 550px;
    height: 40px;
    margin: 0 auto;
    position: relative;
    border-radius: 5px;
    border: solid 1px #bdbdbd;
    background-color: #ffffff;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.09px;
    @media (max-width: 1200px) {
      width: 96.5%;
    }
    @media (max-width: 990px) {
      width: 96%;
    }
    @media (max-width: 768px) {
      width: 93%;
    }
    @media (max-width: 428px) {
      width: 92%;
    }
    @media (max-width: 350px) {
      width: 90%;
    }
    div{
      padding-left: 15px;
    }
    .icon {
      width: 40px;
      height: 40px;
      background-color: #11bb2e;
      position: absolute;
      right: -2px;
      top: 0;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      img {
        padding-top: 8px;
      }
      .img-location{
        padding-left: 10px;
        @media (max-width: 1200px) {
          padding-left: 0;
        }
      }
    }
  }
  #locations_select{
    padding-left: 15px;
    border-radius: 10px;
  }
  .local-center-select{
    justify-content: start;
    @media (max-width: 1200px) {
      justify-content: center;
    }
  }

</style>
